import { Task } from 'packages/lib/api/annotations/contract/task';
import { ValidNextTaskManAction } from 'packages/task-man/service/state-machine/types';
import { stateMachineMap } from 'packages/task-man/service/state-machine/constants';

export {
  type AbstractAnnotationStates,
  mapAnnotationStateToRole,
  mapRoleToAnnotationStates,
} from './utilities';

/**
 * This low-level method is used to enforce predictable and valid task state transitions.
 *
 * Consumers of this method should handle the case where a given task does not have
 * a valid task-edit action (i.e. we cannot `ASSIGN` a task that's already `*Done`).
 *
 * Example Usage:
 * ```ts
 *    const nextAnnotationState = annotationStateMachine(task).ASSIGN;
 *    if (!nextAnnotationState) {
 *      throw new Error(
 *        `Cannot perform action ASSIGN on Task with annotationState "${task.annotationState}"`
 *      );
 *    }
 *    await patch(`/tasks/${task.token}`, { annotationState: nextAnnotationState });
 *
 * ```
 */
export const annotationStateMachine = <
  T extends Pick<Task, 'annotationState'>
>({
  annotationState: curState,
}: T): ValidNextTaskManAction => {
  const r = stateMachineMap.states[curState];
  if (!r) {
    throw new Error(
      'Invalid annotationState provided to Task Management state machine map'
    );
  }
  return r;
};
